import { Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import PageMain from '../../components/Navigation/PageMain/PageMain';
import CreateEditUser from '../../components/Settings/Users/CreateEdit/CreateEditUser';
import { useEditUser } from '../../sic-lib/api/hooks/useUser';
import { EditUserData, NewUserData } from '../../sic-lib/types/NewEditUser';

export default function UsersCreateEditPage() {
    const { userName } = useParams<{ userName?: string }>();

    const { data: user, isLoading, isError } = useEditUser(userName);

    return (
        <PageMain
            pageTitle={!user ? 'Create User' : 'Edit User'}
            showError={isError}
            showLoading={isLoading}
        >
            <div className="settingsPage">
                <div className="settingsPage__wrapper">
                    {userName === 'new' && <CreateEditUser<NewUserData> user={undefined} />}
                    {userName !== 'new' && user && <CreateEditUser<EditUserData> user={user} />}
                    {userName !== 'new' && !user && (
                        <Typography variant="h6">User not found</Typography>
                    )}
                </div>
            </div>
        </PageMain>
    );
}
